import React from 'react';
import { Row, Col } from 'react-grid-system';
import { getLocalizedText as text } from '@vp-dst/localization-util';

import ScreenSizeUtil from 'utils/ScreenSizeUtil';

import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';
import RatingBox from 'components/RatingBox';
import SectionHeading from 'components/SectionHeading';
import Typography from 'components/vistaprintUILibrary/Typography';

function SatisfactionGuaranteed(props) {
  const {
    screenClass,
  } = props;

  const isSmallScreen = ScreenSizeUtil.isSmallScreen(screenClass);

  return (
    <Row
      style={{
        marginBottom: 50,
      }}
    >
      <Col
        md={6}
        style={{
          overflow: 'visible',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <RatingBox
            style={{
              transform: 'rotate(-7deg)',
              marginBottom: 40,
              marginTop: 40,
            }}
          />
        </div>
      </Col>
      <Col md={6}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <SectionHeading
            text={text('satisfaction-guaranteed')}
            alignment={isSmallScreen ? 'center' : 'left'}
          />
          <Typography
            text={text('quality-is-key')}
          />
        </div>
      </Col>
    </Row>
  );
}

SatisfactionGuaranteed.propTypes = {
  ...withScreenClassPropTypes,
};

export default withScreenClass(SatisfactionGuaranteed);



// WEBPACK FOOTER //
// ./src/components/SatisfactionGuaranteed.js